var path = 'views/templates/assetMetadataField.html';
var html = "<div class=\"metadata-field clearfix\"> <div class=\"metadata-field-label\"> <div class=\"text-label\">{{label | formattedMetadataKey}}</div> </div> <div class=\"metadata-field-value\" ng-transclude> </div> </div> ";
window.angular.module('app').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;